import { render } from "./WildBookFallLocation.vue?vue&type=template&id=b811789c&scoped=true&ts=true"
import script from "./WildBookFallLocation.vue?vue&type=script&lang=ts"
export * from "./WildBookFallLocation.vue?vue&type=script&lang=ts"

import "./WildBookFallLocation.vue?vue&type=style&index=0&id=b811789c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b811789c"]])

export default __exports__